/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface FetchShopifyMultipassIdentifierBody
 */
export interface FetchShopifyMultipassIdentifierBody {
  /**
   * The email of the user in Shopify to get the mutlipass identifier for.
   * @type string
   * @memberof FetchShopifyMultipassIdentifierBody
   */
  email: string
}

export function FetchShopifyMultipassIdentifierBodyFromJSON(
  json: any
): FetchShopifyMultipassIdentifierBody {
  return FetchShopifyMultipassIdentifierBodyFromJSONTyped(json, false)
}

export function FetchShopifyMultipassIdentifierBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchShopifyMultipassIdentifierBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    email: json['email'],
  }
}

export function FetchShopifyMultipassIdentifierBodyToJSON(
  value?: FetchShopifyMultipassIdentifierBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    email: value.email,
  }
}
